import { useAuthStore } from '../store'

/**
 * useAuth hook - 简化的认证状态访问
 * 提供用户认证状态、用户信息等
 */
export function useAuth() {
  const { user, customer, isAuthenticated, isLoading, isGuest, login, logout, init } = useAuthStore()
  
  return {
    user,
    customer,
    isAuthenticated,
    isLoading,
    isGuest,
    login,
    logout,
    init,
    // 便捷访问用户信息
    userId: customer?.id,
    userName: customer?.real_name || customer?.email || user,
    userEmail: customer?.email,
    userPhone: customer?.phone,
  }
}

export default useAuth
